import {AppMenuItem} from "../_models/AppMenuItem";

export class MenuItems {

  static readonly Separator: AppMenuItem = {
    id: 'separator',
    iconPath: '',
    textToken: '',
    type: 'separator',
    path: '',
    matchingPaths: [],
    children: [],
    active: false,
    expanded: false,
  };

  static readonly Dashboard: AppMenuItem = {
    id: 'dashboard',
    iconPath: './assets/icons/menu/dashboard-menu-icon.png',
    textToken: 't.navDashboard',
    type: 'path',
    path: '/dashboards',
    matchingPaths: ['/line'],
    active: false,
    expanded: false,
    children: [],
  };

  static readonly Alerts: AppMenuItem = {
    id: 'alerts',
    iconPath: './assets/icons/menu/alert-menu-icon.png',
    textToken: 't.navAlerts',
    type: 'parent-item',
    path: '',
    matchingPaths: [],
    active: false,
    expanded: false,
    children: [
      {
        id: 'alerts-monitor',
        iconPath: './assets/icons/menu/alert-monitor-menu-icon.png',
        textToken: 't.paramRevisionMonitor',
        type: 'path',
        path: '/alerts',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      },
      {
        id: 'alerts-subscription',
        iconPath: './assets/icons/menu/alert-subscriptions-menu-icon.png',
        textToken: 'Subscriptions', // TDC - translation
        type: 'path',
        path: '/alerts/subscriptions',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      }
    ],
  };

  static readonly InsightsExternal: AppMenuItem = {
    id: 'insights',
    iconPath: './assets/icons/menu/insights-menu-icon.png',
    textToken: 'Insights', // TDC - translation
    type: 'parent-item',
    path: '',
    matchingPaths: [],
    active: false,
    expanded: false,
    children: [
      {
        id: 'insights-trends',
        iconPath: './assets/icons/menu/insights-trend-menu-icon.png',
        textToken: 't.navTrends',
        type: 'path',
        path: '/trend-dashboards',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      },
      {
        id: 'insights-reports',
        iconPath: './assets/icons/menu/insights-report-menu-icon.png',
        textToken: 't.navReports',
        type: 'path',
        path: '/report/templates',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      },
    ]
  };

  static readonly Insights: AppMenuItem = {
    id: 'insights',
    iconPath: './assets/icons/menu/insights-menu-icon.png',
    textToken: 'Insights', // TDC - translation
    type: 'parent-item',
    path: '',
    matchingPaths: [],
    active: false,
    expanded: false,
    children: [
      {
        id: 'insights-realtime',
        iconPath: './assets/icons/menu/insights-realtime-menu-icon.png',
        textToken: 't.navDataRealTime',
        type: 'path',
        path: '/real-time-data-streamer/asset',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      },
      {
        id: 'insights-historic',
        iconPath: './assets/icons/menu/insights-historic-menu-icon.png',
        textToken: 't.navDataHistoric',
        type: 'path',
        path: '/historic-data',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      },
      {
        id: 'insights-trends',
        iconPath: './assets/icons/menu/insights-trend-menu-icon.png',
        textToken: 't.navTrends',
        type: 'path',
        path: '/trend-dashboards',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      },
      {
        id: 'insights-reports',
        iconPath: './assets/icons/menu/insights-report-menu-icon.png',
        textToken: 't.navReports',
        type: 'path',
        path: '/report/templates',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      },
    ]
  };

  static readonly Resources: AppMenuItem = {
    id: 'resources',
    iconPath: './assets/icons/menu/resources-menu-icon.png',
    textToken: 'Resources', // TDC - translation
    type: 'parent-item',
    path: '',
    matchingPaths: [],
    active: false,
    expanded: false,
    children: [
      {
        id: 'resources-tutorials',
        iconPath: './assets/icons/menu/resources-tutorials-menu-icon.png',
        textToken: 't.tutorialsMenu',
        type: 'path',
        path: '/tutorials',
        matchingPaths: [],
        active: false,
        expanded: false,
        children: [],
      },
    ]
  };

  static readonly Administration: AppMenuItem = {
    id: 'administration',
    iconPath: './assets/icons/menu/administration-menu-icon.png',
    textToken: 't.navAdministration',
    type: 'path',
    path: '/config',
    matchingPaths: ['/cms/', '/tile-library', '/manage-config', '/parameter-configs'],
    active: false,
    expanded: false,
    children: [],
    accessControlName: 'AppComponent.administrationMenu',
  };

  static readonly UserProfile: AppMenuItem = {
    id: 'user-profile',
    iconPath: '',
    textToken: '',
    type: 'user-profile',
    path: '',
    matchingPaths: [],
    active: false,
    expanded: false,
    children: [],
  };

  static readonly Logout: AppMenuItem = {
    id: 'logout',
    iconPath: './assets/icons/menu/logout-menu-icon.png',
    textToken: 'Sign Out', // TDC - translation
    type: 'log-out',
    path: '',
    matchingPaths: [],
    active: false,
    expanded: false,
    children: [],
  };

  static readonly LeaveImpersonation: AppMenuItem = {
    id: 'leave-impersonation',
    iconPath: './assets/icons/close.png',
    textToken: 't.impersonateBtn',
    type: 'leave-impersonation',
    path: '',
    matchingPaths: [],
    active: false,
    expanded: false,
    children: [],
  };
}
